import * as React from "react";
const SvgBtnBMoveList = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 9v2H0V9h12zm0-4v2H0V5h12zm0-4v2H0V1h12z", fill: "#000", fillRule: "evenodd" }));
export default SvgBtnBMoveList;
